import {
  OPEN_CONFIGURATION,
  OPEN_PREVIEW,
  CLOSE_CONFIGURATION,
  CLOSE_PREVIEW,
  ADD_PARTICIPANT,
  UPDATE_PARTICIPANTS,
  SET_TEMPLATE,
  RESET_TEMPLATE,
  UNRESET,
  OPEN_GENERAL,
  CLOSE_GENERAL,
  SET_DOCUMENT,
  UPDATE_DOCUMENT,
  SET_STATUS,
  FILL_MY_DATA,
  RESET_FILL_MY_DATA,
  SET_SHIELD_TYPE,
  SET_LANGUAGE,
  RESET_DOCUMENT,
  SET_DOCUMENT_PARTICIPANTS,
  SET_PARTICIPANTS,
  SET_NUM_PAGES,
  SET_CURRENT_PAGE,
  SET_SIGNATURES,
  UPDATE_SIGNATURE,
  SET_CURRENT_ELEMENT,
  CHANGED_DATA,
  RESTORE_ITEM,
  RESTORE_DOCUMENT_ITEM,
  SET_LAWYER_NEEDED,
  ADD_TO_CART,
  SET_IS_INVOICE_NEEDED,
  SET_CHECKOUT_INFO,
  REMOVE_SIGNATURE,
  DELETE_CART_ITEM,
  SET_EDIT_FIELD,
  ADD_NEW_VARIABLE,
  DRAG_NEW_VARIABLE,
  SET_JURISDICTION,
  SET_SIGNATURE_TYPE,
  SET_CURRENT_STEP,
  SET_TOTAL_STEPS,
  SET_PROGRESS,
  SET_AI_DATA,
} from "./types";

import produce from "immer";

import { mongoObjectId, getPrice } from "../../utils";

function generateParticipant({ currentLength = 0, label }) {
  return {
    _id: mongoObjectId(),
    isNewParticipant: true,
    obligation: "individual",
    name: "",
    last_name: "",
    representative: "",
    phone: "",
    email: "",
    label,
  };
}

export const initialEditorState = {
  document: {},
  checkoutInfo: { isLawyerNeeded: false, isInvoiceNeeded: false },
  originalDocument: {},
  publicTemplate: {},
  fillMyData: "",
  language: "es",
  shieldType: "",
  signatureType: "autograph",
  jurisdiction: "mx",
  stampNom: false,
  currentPage: 1,
  numPages: 0,
  numPagesArr: [],
  currentElement: {},
  participants: [],
  signatures: {},
  isPdf: false,
  isDynamic: false,
  carrito: [],
  isTemplate: false,
  totalSteps: 1,
  currentStep: 1,
  progress: 0,
};

export const editorReducer = (state, action) => {
  switch (action.type) {
    case SET_DOCUMENT:
      const isPdf =
        action.document?.pluginType === "pdf" ||
        action.document?.originalType === "pdf";
      const isDynamic = action.document?.isDynamic;
      const isTemplate =
        action.mode === "template" ||
        action.document?.originalType === "template";
      const cart = [];
      let signatures = {};
      if (isPdf) {
        signatures = action.document?.participants?.reduce(
          (obj, participant) => {
            obj[participant._id] = participant.signatures;
            return obj;
          },
          {}
        );
        action.document.originalType = "pdf";
      }

      if (isTemplate) {
        delete action.document._id;
        action.document.status = "";
        action.document.templateId = action.documentId;
      }
      console.log({ action });
      if (action.publicTemplate?.stripeInfo?.id) {
        cart.push({
          producto: "Plantilla Premium",
          importe: Number(
            getPrice(
              action.publicTemplate.stripeInfo?.price,
              action.publicTemplate.stripeInfo?.currency
            ).replace("$", "")
          ),
        });
      }
      let totalSteps = 1;
      if (action.mode === "public-template") {
        const participantsCount = action.document.participants.length;
        totalSteps = 3 * participantsCount;
      }

      console.log({ action });

      return {
        ...state,
        document: action.document,
        documentId: action.documentId,
        originalDocument: action.setOriginal
          ? action.document
          : state.originalDocument,
        participants: action.document.participants,
        isEditable: ["DRAFT", ""].includes(action.document.status),
        publicTemplate: action.publicTemplate,
        carrito: cart,
        isPdf,
        isDynamic,
        isTemplate,
        signatures,
        currentStep: 1,
        totalSteps,
        jurisdiction: action?.document?.jurisdiction || state.jurisdiction,
        signatureType: action?.document?.signatureType || state.signatureType,
      };
    case RESET_DOCUMENT:
      let signatures2 = {};
      if (state.isPdf) {
        signatures2 = state.originalDocument?.participants?.reduce(
          (obj, participant) => {
            obj[participant._id] = participant.signatures;
            return obj;
          },
          {}
        );
      }

      return {
        ...state,
        document: state.originalDocument,
        participants: state.originalDocument.participants,
        signatures: signatures2,
        fillMyData: "",
      };
    case SET_STATUS:
      return {
        ...state,
        status: action.status,
      };
    case SET_LAWYER_NEEDED:
      const nextL = produce(state, (draft) => {
        draft.checkoutInfo["isLawyerNeeded"] = action.data.isLawyerNeeded;
      });
      return nextL;
    case SET_IS_INVOICE_NEEDED:
      const nextS = produce(state, (draft) => {
        draft.checkoutInfo["isInvoiceNeeded"] = action.data.isInvoiceNeeded;
      });
      return nextS;
    case SET_CHECKOUT_INFO:
      return {
        ...state,
        document: {
          ...state.document,
          participants: state.participants,
          checkoutInfo: {
            isLawyerNeeded: action.data.isLawyerNeeded,
            invoiceRFC: action.data.invoiceRFC,
            invoiceEmail: action.data.invoiceEmail,
            isInvoiceNeeded: action.data.isInvoiceNeeded,
            paymentTotal: action.data.paymentTotal,
            isMoral: action.data.isMoral,
          },
        },
      };
    case ADD_TO_CART:
      const nextStateX = produce(state, (draft) => {
        draft.carrito.push(action.data);
      });
      return nextStateX;
    case CHANGED_DATA:
      console.log(action.data);
      //const elementooriginal = state.originalDocument.elements.find(e=>e._id===action.data._id);
      //const elementoOriginal = state.document.elements.find(e=>e._id===action.data._id);
      //elementooriginal.modifiedContent = action.data.modified
      const nextState = produce(state, (draft) => {
        const index = draft.document.elements.findIndex(
          (x) => x._id === action.data._id
        );
        const indexCarrito = draft.carrito.findIndex(
          (x) => x._id === action.data._id
        );
        if (state.originalDocument.elements[index] !== action.data) {
          if (index !== -1)
            draft.document.elements[index].children = action.data.children;
          if (index !== -1)
            draft.document.elements[index].isModified = action.data.isModified;
          if (index !== -1)
            draft.document.elements[index].type = action.data.type;
          if (index !== -1)
            draft.document.elements[index].children = action.data.children;
          if (index !== -1) draft.document.elements[index].listIndex = index;
          if (index !== -1)
            draft.document.elements[index].price = action.data.price;
          if (index !== -1)
            draft.document.elements[index].textAlign = action.data.textAlign;
          if (indexCarrito === -1)
            draft.carrito.push({
              producto: `Edición del elemento ${index + 1}`,
              importe: action.data.price,
              _id: action.data._id,
              index: index,
            });
          else if (indexCarrito !== -1)
            draft.carrito[indexCarrito] = {
              producto: `Edición del elemento ${index + 1}`,
              importe: action.data.price,
              _id: action.data._id,
              index: index,
            };
        }
      });
      return nextState;
    case RESTORE_ITEM:
      console.log(action.data);
      const nextState2 = produce(state, (draft) => {
        if (action.data.index !== -1)
          draft.document.elements[action.data.index].children =
            state.originalDocument.elements[action.data.index].children;
        if (action.data.index !== -1)
          draft.document.elements[action.data.index].isModified = false;
        draft.carrito.splice(
          draft.carrito.findIndex(
            (x) => x._id === action.data.id
          ) /*the index */,
          1
        );

        draft.checkoutInfo.isLawyerNeeded = false;
      });
      return nextState2;
    case RESTORE_DOCUMENT_ITEM:
      const docInitialState = produce(state, (draft) => {
        if (action.data.index !== -1)
          draft.document.elements[action.data.index].children =
            state.originalDocument.elements[action.data.index].children;
        if (action.data.index !== -1)
          draft.document.elements[action.data.index].isModified = false;
        // draft.carrito
        //   .splice
        // draft.carrito.findIndex(
        //   (x) => x._id === action.data.id
        // ) /*the index */,
        // ();

        draft.checkoutInfo.isLawyerNeeded = false;
      });
      return docInitialState;
    case DELETE_CART_ITEM:
      const newCart = produce(state, (draft) => {
        if (action.data.index !== -1)
          draft.carrito.splice(
            draft.carrito.findIndex(
              (x) => x._id === action.data.id
            ) /*the index */,
            1
          );
      });
      return newCart;
    case SET_SHIELD_TYPE:
      return {
        ...state,
        shieldType: action.shieldType,
        stampNom: ["shield2", "shield3"].includes(action.shieldType.value),
      };
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };
    case SET_SIGNATURE_TYPE:
      return {
        ...state,
        signatureType: action.signatureType,
      };
    case SET_JURISDICTION:
      return {
        ...state,
        jurisdiction: action.jurisdiction,
      };
    case SET_EDIT_FIELD:
      return {
        ...state,
        editorField: action.data,
      };
    case ADD_NEW_VARIABLE:
      return {
        ...state,
        variableToAdd: action.data,
      };

    case DRAG_NEW_VARIABLE:
      return {
        ...state,
        variableToDrop: action.data,
      };
    case SET_PROGRESS:
      return {
        ...state,
        progress: action.progress,
      };
    case SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.currentStep,
      };
    case SET_TOTAL_STEPS:
      return {
        ...state,
        totalSteps: action.totalSteps,
      };
    case FILL_MY_DATA:
      const profile = action.profile;
      const newParticipants = state.document.participants.map(
        (participant, i) => {
          if (action.name.includes(participant._id)) {
            return {
              ...participant,
              name:
                participant.obligation === "legal"
                  ? profile.office.name
                  : profile.givenName,
              last_name: profile.familyName,
              email: profile.email,
              label: participant.label,
              phone: profile.phone,
              representative: profile.office
                ? profile.office.representative
                : "",
            };
          }

          return state.document.participants[i];
        }
      );

      return {
        ...state,
        document: {
          ...state.document,
          participants: newParticipants,
        },
        participants: newParticipants,
        fillMyData: action.name,
      };
    case RESET_FILL_MY_DATA:
      const originalDocument = state.originalDocument;
      const participantToReset =
        originalDocument.participants.find((p) =>
          state.fillMyData.includes(p._id)
        ) ?? generateParticipant({ label: "" });
      const participants = state.participants.map((participant) => {
        if (state.fillMyData.includes(participant._id)) {
          return participantToReset;
        }
        return participant;
      });

      return {
        ...state,
        document: {
          ...state.document,
          participants: participants,
        },
        participants: participants,
        fillMyData: "",
      };
    case SET_PARTICIPANTS:
      return {
        ...state,
        participants: action.participants,
      };
    case SET_DOCUMENT_PARTICIPANTS:
      return {
        ...state,
        document: {
          ...state.document,
          participants: action.participants,
        },
      };
    case SET_AI_DATA:
      return {
        ...state,
        aiData: action.data,
      };
    case SET_NUM_PAGES:
      return {
        ...state,
        numPages: action.numPages,
        numPagesArr: new Array(action.numPages),
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.pageNumber,
      };

    case SET_SIGNATURES:
      return {
        ...state,
        signatures: action.signatures,
      };
    case UPDATE_SIGNATURE:
      const participantSignatures = state.signatures[action.participantId];
      const newSignatures = participantSignatures.map((currentSign) => {
        if (currentSign._id === action.signature._id) {
          return action.signature;
        }
        return currentSign;
      });

      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.participantId]: newSignatures,
        },
      };
    case "add-signature":
      const participantSignatures2 = state.signatures[action.participantId];

      const newSignatures2 = [
        ...participantSignatures2,
        {
          _id: mongoObjectId(),
          left: 120,
          top: 300,
          width: 200,
          height: 100,
          page: state.currentPage,
        },
      ];
      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.participantId]: newSignatures2,
        },
      };
    case REMOVE_SIGNATURE:
      const participantSignatures3 = state.signatures[action.participantId];

      const newSignatures3 = participantSignatures3.filter(
        (sign) => sign._id !== action.signatureId
      );

      return {
        ...state,
        signatures: {
          ...state.signatures,
          [action.participantId]: newSignatures3,
        },
      };
    case "update-participants":
      return {
        ...state,
        participants: state.participants.map((participant) => {
          return {
            ...participant,
            ...action.participants[participant._id],
          };
        }),
      };
    case "add-participant":
      const newParticipant = generateParticipant({
        label: `Participante ${(state.participants?.length ?? 0) + 1}`,
      });
      const newParticipants2 = [...state.participants, newParticipant];

      return {
        ...state,
        document: {
          ...state.document,
          participants: newParticipants2,
        },
        participants: newParticipants2,
        signatures: {
          ...state.signatures,
          [newParticipant._id]: [],
        },
      };
    case "remove-participant":
      const filteredParticipants = state.participants.filter(
        (participant) => participant._id !== action.participantId
      );

      return {
        ...state,
        document: {
          ...state.document,
          participants: filteredParticipants,
        },
        participants: filteredParticipants,
        signatures: Object.fromEntries(
          Object.entries(state.signatures).filter(
            ([key, value]) => key !== action.participantId
          )
        ),
      };
    case SET_CURRENT_ELEMENT:
      return {
        ...state,
        currentElement: action.element,
      };
    default:
      return state;
  }
};
